import { FC, PropsWithChildren, useState } from 'react';
import { DbConfigContext } from './DbConfigContext';

export const DbConfigContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [json, setJson] = useState<string>('');
  const [jsonIsValid, setJsonIsValid] = useState<boolean>(true);
  const [lastSavedJson, setLastSavedJson] = useState<string>('');
  const [name, setName] = useState<string>('');

  return (
    <DbConfigContext.Provider
      value={{
        json,
        jsonIsDirty: lastSavedJson !== json,
        jsonIsValid,
        name,
        setJson,
        setJsonIsValid,
        setLastSavedJson,
        setName,
      }}
    >
      {children}
    </DbConfigContext.Provider>
  );
};
